export default __webpack_public_path__ + "static/media/Cofactr_logomark_clover_256x256.432b8edb.png";